import React from 'react';
import { Pagination } from 'antd';
import './SimplePagination.css';

const SimplePagination = ({ 
  current, 
  total, 
  pageSize, 
  onChange, 
  onShowSizeChange,
  showSizeChanger = false,
  showQuickJumper = false,
  showTotal = true,
  size = 'default',
  className = '',
  ...props 
}) => {
  return (
    <div className={`simple-pagination-wrapper ${className}`}>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={showQuickJumper}
        showTotal={showTotal ? (total, range) => 
          <span className="simple-pagination-info">
            {range[0]}-{range[1]} sur {total}
          </span> : false
        }
        size={size}
        className="simple-pagination"
        simple={false}
        {...props}
      />
    </div>
  );
};

export default SimplePagination;
